import { CreditCard } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

interface BillingEmptyStateProps {
  className?: string;
}

export function BillingEmptyState({ className }: BillingEmptyStateProps) {
  const { LL } = useI18nContext();

  return (
    <div
      className={cn(
        'flex min-h-[40vh] min-w-0 flex-col items-center justify-center gap-4 px-4 text-center',
        className
      )}
    >
      <CreditCard
        className="size-16 text-muted-foreground sm:size-20"
        strokeWidth={1.25}
        aria-hidden
      />
      <div className="flex max-w-md flex-col gap-2">
        <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">
          {LL.billingPage.emptyState.title()}
        </h2>
        <p className="text-sm text-muted-foreground sm:text-base">
          {LL.billingPage.emptyState.description()}
        </p>
      </div>
    </div>
  );
}
